export default "__VITE_ASSET__B4q16I9$__"